import React from "react";
import { toast as rtoast } from "react-toastify";



const methodFor = (type) => {
  switch (type) {
    case "danger":
    case "error":
      return rtoast.error;
    case "success":
      return rtoast.success;
    case "warning":
      return rtoast.warning;
    case "info":
      return rtoast.info;
    default:
      return rtoast; // neutral default toast
  }
};


const contentFor = (message) => {
  const props = message && message.props ? message.props : null;
  if (props && props.title && props.children != null && props.children !== "") {
    return (
      <div>
        <div style={{ fontWeight: 600, marginBottom: 2 }}>{props.title}</div>
        <div>{props.children}</div>
      </div>
    );
  }
  if (props) return props.children != null ? props.children : props.title;
  return message; // plain string / node
};

const optionsFor = (message) => {
  const d = message && message.props ? message.props.duration : undefined;
  return typeof d === "number" ? { autoClose: d } : undefined;
};

const toast = (message) => toast.push(message);

// Second arg (the old `{ placement }`) is accepted but ignored — react-toastify
// renders from the single <ToastContainer> in App.js (top-right).
toast.push = (message, _options) => {
  const type = message && message.props ? message.props.type : undefined;
  return methodFor(type)(contentFor(message), optionsFor(message));
};

toast.remove = (key) => rtoast.dismiss(key);
toast.removeAll = () => rtoast.dismiss();

export default toast;
